import { useEffect, useMemo, useState } from "react";
import { IsNullOrEmpty, IsNullOrZero } from "../../core/utility";
import { get, post } from "../../core/client";
import { useLocation } from "react-router-dom";
import { COMM_TYPES } from "../../core/consts";
import Grid from "@mui/material/Grid";
import Input from "../../components/inputs/text-field-input";
import Select from "../../components/inputs/select";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Alert from "@mui/material/Alert";
import { CustomButton } from "../../components/buttons";
import { Chat, Email, TaskAlt } from "@mui/icons-material";
import { ResponseWithSuccess } from "../../core/client/Models";

interface StateModel {
    subscriber: string;
    type: string;
    reason: number | null;
    reasonOther: string;
    checkKocAilem: boolean;
    checkKocAilemMarket: boolean;
    checkOutboundPerm: boolean;
    checkKocailemCocuk:boolean;
    isUnderAge:boolean;
}

interface InputErrorModel {
    name: string;
    errorText: string;
}

const useQuery = () => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}

const Unsubscribe = () => {

    let query = useQuery();
    const encriptedText = query.get('subs');

    const initialState: StateModel = {
        subscriber: "",
        type: "",
        reason: null,
        reasonOther: "",
        checkKocAilem: false,
        checkKocAilemMarket: false,
        checkOutboundPerm: false,
        checkKocailemCocuk:false,
        isUnderAge:false
    };
    const [state, setState] = useState<StateModel>(initialState);
    const [reasons, setReasons] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [inputErrors, setInputErrors] = useState<Array<InputErrorModel>>([]);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [isSend, setIsSend] = useState<boolean>(false);
    const [sendLoading, setSendLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!IsNullOrEmpty(state.type))
            loadReasons(state.type);
    }, [state.type]);

    useEffect(() => {
        if (!IsNullOrEmpty(encriptedText)) {
            loadMaskedSubscriber(encriptedText as string)
        }
    }, [encriptedText])

    const loadReasons = async (reqType: string) => {
        const type = reqType === 'email' ? '1' : '2'
        setLoading(true);
        const { data, fail, errorMessage } = await get<any>(`api/membership/list-unsubscribe-reasons/${type}`);
        if (data) {
            setReasons(data.items);
        }
        setLoading(false);
    }

    const loadMaskedSubscriber = async (encriptedText: string) => {
        const request = {
            text: encriptedText
        }
        const { data, fail, errorMessage } = await post<any>('api/membership/get-masked-subscriber', request);
        if (data) {
            setState(prev => ({
                ...prev,
                subscriber: data.subscriber,
                type: data.type,
                isUnderAge:data.isUnderAge
            }));
        }
    }

    const handleChange = (e: any) => {
        setState(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    }

    const handleCheckbox = (e: any) => {
        setState(prev => ({
            ...prev,
            [e.target.name]: e.target.checked
        }));
    }

    const handleSend = async (model: StateModel) => {

        if (!validate(model)) return;

        setSendLoading(true);
        const request = {
            subscriber: encriptedText,
            reason: model.reason,
            reasonDetail: model.reasonOther,
            unsubscribeKocAilem: model.checkKocAilem,
            unsubscribeKocAilemMarket: model.checkKocAilemMarket,
            unsubscribeOutbound: model.checkOutboundPerm,
            unsubscribeKocailemCocuk:model.checkKocailemCocuk
        }
        const { data, fail, errorMessage } = await post<ResponseWithSuccess>('api/membership/unsubscribe', request);
        if (data && data.success) {
            //success
            setIsSend(true);
        }
        setSendLoading(false);
    }

    const validate = (model: StateModel) => {
        setInputErrors([]);
        setErrorMessage("");
        let isValid = true;

        if (IsNullOrZero(model.reason)) {
            const error: InputErrorModel = {
                name: 'reason',
                errorText: 'Boş bırakılamaz'
            };
            setInputErrors((prev: Array<InputErrorModel>) => [...prev, error]);
            isValid = false;
        }
        else if (model.reason === 5 && IsNullOrEmpty(model.reasonOther)) {
            const error: InputErrorModel = {
                name: 'reasonOther',
                errorText: 'Boş bırakılamaz'
            };
            setInputErrors((prev: Array<InputErrorModel>) => [...prev, error]);
            isValid = false;
        }
        if (!model.checkKocAilem && !model.checkKocAilemMarket && !model.checkOutboundPerm&& !model.checkKocailemCocuk) {
            setErrorMessage("Lütfen hangi üyelikten çıkacağınızı seçiniz.");
            isValid = false;
        }

        return isValid;
    }

    return (
        <Grid container spacing={2}>
            <Grid item sm={6}>
                <aside>
                    {state.type === COMM_TYPES.EMAIL ? (
                        <div className="text">
                            <p className="head">Seni özleyeceğiz!</p>
                            <p>KoçAilem'deki en özel ayrıcalıkları senin için oluşturuyor ve özenle seçerek <span className="nowrap">e-posta</span> ile gönderiyoruz.</p>
                            <p>Yaptığımız anket sonuçlarına göre üyelerimizin %91'i <span className="nowrap">e-posta</span> gönderim sıklığından memnun.</p>
                            <p>Eğer, <span className="nowrap">e-posta</span> almak istemiyorsan üyelikten ayrılman yeterli, en geç 72 saat içerisinde sana ayrıldığın konu ile ilgili <span className="nowrap">e-posta</span> gönderimini durduracağız.</p>
                            <p>Tekrar sana özel hazırlanan ayrıcalıklardan haberdar olmak istersen, seni aramızda görmekten memnuniyet duyarız. KoçAilem Mobil üzerinden izinlerini yönetebilirsin.</p>
                        </div>
                    ) : state.type === COMM_TYPES.PHONE ? (
                        <div className="text">
                            <p className="head">Seni özleyeceğiz!</p>
                            <p>KoçAilem'deki en özel ayrıcalıkları senin için oluşturuyor ve özenle seçerek SMS ile gönderiyoruz.</p>
                            <p>Yaptığımız anket sonuçlarına göre üyelerimizin %91'i SMS gönderim sıklığından memnun.</p>
                            <p>Eğer, SMS almak istemiyorsan üyelikten ayrılman yeterli, en geç 72 saat içerisinde sana ayrıldığın konu ile ilgili SMS gönderimini durduracağız.</p>
                            <p>Tekrar sana özel hazırlanan ayrıcalıklardan haberdar olmak istersen, seni aramızda görmekten memnuniyet duyarız. KoçAilem Mobil üzerinden izinlerini yönetebilirsin.</p>
                        </div>
                    ) : null}
                </aside>
            </Grid>
            <Grid item sm={6}>
                <aside>
                    <div className="form">
                        {!isSend ? (
                            <>
                                {state.type === COMM_TYPES.EMAIL && <div className="icon"><Email /></div>}
                                {state.type === COMM_TYPES.PHONE && <div className="icon"><Chat /></div>}
                                <Input
                                    id="subscriber"
                                    name="subscriber"
                                    caption=""
                                    className="mb-2"
                                    readOnly
                                    onChange={handleChange}
                                    value={state.subscriber}
                                />
                                <Select
                                    id="reason"
                                    name="reason"
                                    caption="Çıkış nedeni"
                                    className="mb-2"
                                    disabled={loading}
                                    loading={loading}
                                    onChange={handleChange}
                                    options={{
                                        data: reasons,
                                        displayField: 'name',
                                        displayValue: 'id',
                                        selected: state.reason
                                    }}
                                    errorText={inputErrors.find(x => x.name === 'reason')?.errorText}
                                />
                                {(state.reason === 5 || state.reason === 10) && (
                                    <Input
                                        id="reasonOther"
                                        name="reasonOther"
                                        caption="Çıkış nedeni detay"
                                        className="mb-2"
                                        multiline
                                        rows={3}
                                        onChange={handleChange}
                                        value={state.reasonOther}
                                        errorText={inputErrors.find(x => x.name === 'reasonOther')?.errorText}
                                    />
                                )}
                                <FormControlLabel
                                    control={<Checkbox checked={state.checkKocAilem} onChange={handleCheckbox} name="checkKocAilem" color="primary" />}
                                    label={`KoçAilem ${state.type === COMM_TYPES.EMAIL ? "e-posta" : "SMS"} üyeliğinden çık.`}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={state.checkKocAilemMarket} onChange={handleCheckbox} name="checkKocAilemMarket" color="primary" />}
                                    label={`KoçAilem Market ${state.type === COMM_TYPES.EMAIL ? "e-posta" : "SMS"} üyeliğinden çık.`}
                                />
                                 {!state.isUnderAge &&<FormControlLabel
                                    control={<Checkbox checked={state.checkKocailemCocuk} onChange={handleCheckbox} name="checkKocailemCocuk" color="primary" />}
                                    label={`KoçAilem Çocuk ${state.type === COMM_TYPES.EMAIL ? "e-posta" : "SMS"} üyeliğinden çık.`}
                                />}
                                {state.type === COMM_TYPES.PHONE && (
                                    <FormControlLabel
                                        control={<Checkbox checked={state.checkOutboundPerm} onChange={handleCheckbox} name="checkOutboundPerm" color="primary" />}
                                        label={`KoçAilem arama iznini sonlandır.`}
                                    />
                                )}
                                {!IsNullOrEmpty(errorMessage) && (
                                    <Alert severity="error" className="mb-2">{errorMessage}</Alert>
                                )}
                                <CustomButton
                                    text="Gönder"
                                    className="btn-primary mt-2"
                                    fullWidth
                                    disabled={loading || sendLoading}
                                    loading={sendLoading}
                                    onClick={() => handleSend(state)} />
                            </>
                        ) : (
                            <div className="success-container">
                                <TaskAlt className='success-icon' color='success' />
                                <p>Çıkış talebiniz alınmıştır.</p>
                            </div>
                        )}
                    </div>
                </aside>
            </Grid>
        </Grid >
    )
}

export default Unsubscribe;